// Type definitions for SignalR notification integration

export interface NotificationPayload {
	id: string;
	title: string;
	message: string;
	type: string;
	subType?: number;
	timestamp: string;
	data?: Record<string, any>;
}

export interface VendingStepData {
	workflowId: string;
	typeOfEvent: string;
	subTypeOfEvent: string;
	timestamp: string;
}

export interface SignalRNegotiateResponse {
	url: string;
	accessToken: string;
}

export enum NotificationConnectionState {
	Disconnected = "Disconnected",
	Connecting = "Connecting",
	Connected = "Connected",
	Reconnecting = "Reconnecting",
	Failed = "Failed",
}

// Callback types for hybrid approach (Redux + Direct subscriptions)
export type NotificationCallback = (payload: NotificationPayload) => void;
export type VendingStatusCallback = (data: VendingStepData) => void;
export type ConnectionStateCallback = (state: NotificationConnectionState) => void;

export enum NotificationFilter {
	All = 1,
	Alert = 2,
	Update = 3,
}

export enum BroadcastNotificationSubType {
	PushNotification = 1,
	PopUpNotification = 2,
	ListNotification = 3,
	BannerNotification = 4,
	ScrollNotification = 5,
	BoxNotification = 6,
}

export enum NotificationType {
	SolarRecommendation = 1,
	ServiceRequest = 2,
	CustomerEnergyAccountPendingStatusChangedRequest = 3,
	VendingToken = 4,
	ServiceRequestPayment = 5,
	WalletDebited = 6,
	BorrowToken = 7,
	WalletCredited = 8,
	BpsBilling = 9,
	UnitRunningLow = 10,
	Broadcast = 11,
	StatementOfAccountReport = 12,
	Refund = 14
}

export enum NotificationGroup{
	UNKNOWN = 0,
	ALERT = 1,
	UPDATE = 2
}

// API notification (from REST endpoint, persisted)
export interface UserNotification {
	id: string;
	title: string;
	message: string;
	type: NotificationType;
	subType?: number;
	createdAt: string;
	readAt?: string;
	notificationContext: string;
	group?: NotificationGroup; //alert, update
	groupId?: string; //push, popup, list

}



export interface BroadcastNotificationDetail {
    id: string;
    title?: string;
    message?: string;
    image?: string;
    type: number;
    stopMethod?: number;
    createdAt: string;
    bannerLinking?: boolean;
    bannerUrl?: string;
    addButton?: boolean;
    buttonLabel?: string;
    buttonLinkScreen?: string;
	turnOnOff?: boolean;
}

export interface MyBroadcastNotificationsResponse {
    bannerNotification?: BroadcastNotificationDetail;
    scrollNotification?: BroadcastNotificationDetail;
    boxNotification?: BroadcastNotificationDetail;
    popupNotification?: BroadcastNotificationDetail[];
}

export interface PaginatedNotificationsResponse {
	items: UserNotification[];
	totalPages: number;
	count: number;
	page: number;
	pageIndex: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
}
